import React from 'react';

const MaterialSpecifications = ({ data, updateData }) => {
  const handleLGSSelection = (field, value) => {
    updateData({
      materialSpecs: {
        ...data.materialSpecs,
        [field]: value
      }
    });
  };

  const handleAllowanceChange = (field, value) => {
    updateData({
      materialSpecs: {
        ...data.materialSpecs,
        allowances: {
          ...data.materialSpecs?.allowances,
          [field]: value
        }
      }
    });
  };

  const orderLengthOptions = [
    { value: '2.4m', label: '2.4m' },
    { value: '3.0m', label: '3.0m' },
    { value: '5.0m', label: '5.0m' }
  ];

  const paintOrderSizes = [
    { value: '4L', label: '4L' },
    { value: '16L', label: '16L' }
  ];

  const tapeOrderSizes = [
    { value: '75m', label: '75m roll' },
    { value: '150m', label: '150m roll' }
  ];

  return (
    <div className="card p-3">
      <h3 className="font-semibold mb-3">2.4. MATERIAL SPECIFICATIONS</h3>
      
      {/* A. Light Gauge Steel Framing (LGS) - visible for non-painted slab options */}
      {data.ceilingType && data.ceilingType !== 'ceiling_painted_slab' && (
        <div className="p-4 border border-blue-200 rounded-lg bg-blue-50 mb-6">
          <div className="font-semibold mb-4 text-blue-800">A. Light Gauge Steel Framing (LGS)</div>
          
          {/* LGS Brand Selection */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div className="md:col-span-3">
              <label className="grid gap-1">
                <span className="label">Brand</span>
                <select 
                  className="input"
                  value={data.materialSpecs?.lgsBrand || ''}
                  onChange={(e) => handleLGSSelection('lgsBrand', e.target.value)}
                >
                  <option value="">Select LGS brand</option>
                  <option value="geigher">Geigher Steel Framing (Main)</option>
                  <option value="alternate_lgs_1">Alternate LGS Brand 1</option>
                  <option value="alternate_lgs_2">Alternate LGS Brand 2</option>
                </select>
              </label>
            </div>
          </div>

          {/* Enhanced LGS Components Table with Order Lengths */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr>
                  <th className="border border-gray-300 bg-gray-100 p-2 text-left">MF CODE</th>
                  <th className="border border-gray-300 bg-gray-100 p-2 text-left">Material</th>
                  <th className="border border-gray-300 bg-gray-100 p-2 text-left">Specifications</th>
                  <th className="border border-gray-300 bg-gray-100 p-2 text-left">Order Length</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-gray-300 p-2">09 22 00</td>
                  <td className="border border-gray-300 p-2">Hanger (with Clips and Brackets)</td>
                  <td className="border border-gray-300 p-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <div>
                        <label className="grid gap-1">
                          <span className="text-xs font-medium">TYPE</span>
                          <select 
                            className="input text-sm"
                            value={data.materialSpecs?.hangerType || ''}
                            onChange={(e) => handleLGSSelection('hangerType', e.target.value)}
                          >
                            <option value="">Select type</option>
                            <option value="solid_rod">Solid Rod</option>
                            <option value="threaded_rod">Threaded Rod</option>
                            <option value="suspension_wire">Suspension Wire</option>
                          </select>
                        </label>
                      </div>
                      <div>
                        <label className="grid gap-1">
                          <span className="text-xs font-medium">DROP LENGTH</span>
                          <select 
                            className="input text-sm"
                            value={data.materialSpecs?.hangerDropLength || ''}
                            onChange={(e) => handleLGSSelection('hangerDropLength', e.target.value)}
                          >
                            <option value="">Select length</option>
                            <option value="upto_300mm">Up to 300mm</option>
                            <option value="301_to_600mm">301 to 600mm</option>
                            <option value="601_to_900mm">601 to 900mm</option>
                          </select>
                        </label>
                      </div>
                    </div>
                  </td>
                  <td className="border border-gray-300 p-2">
                    <select 
                      className="input text-sm"
                      value={data.materialSpecs?.hangerOrderLength || ''}
                      onChange={(e) => handleLGSSelection('hangerOrderLength', e.target.value)}
                    >
                      <option value="">Select order length</option>
                      {orderLengthOptions.map(option => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr>
                  <td className="border border-gray-300 p-2">09 22 00</td>
                  <td className="border border-gray-300 p-2">Wall Angle</td>
                  <td className="border border-gray-300 p-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <div>
                        <label className="grid gap-1">
                          <span className="text-xs font-medium">TYPE</span>
                          <select 
                            className="input text-sm"
                            value={data.materialSpecs?.wallAngleType || ''}
                            onChange={(e) => handleLGSSelection('wallAngleType', e.target.value)}
                          >
                            <option value="">Select type</option>
                            <option value="single">Single</option>
                            <option value="double">Double (for Shadow gap)</option>
                          </select>
                        </label>
                      </div>
                      <div>
                        <label className="grid gap-1">
                          <span className="text-xs font-medium">THICKNESS</span>
                          <select 
                            className="input text-sm"
                            value={data.materialSpecs?.wallAngleThickness || ''}
                            onChange={(e) => handleLGSSelection('wallAngleThickness', e.target.value)}
                          >
                            <option value="">Select thickness</option>
                            <option value="0.6mm">0.6mm</option>
                            <option value="0.7mm">0.7mm</option>
                            <option value="0.8mm">0.8mm</option>
                            <option value="0.9mm">0.9mm</option>
                            <option value="1.0mm">1.0mm</option>
                          </select>
                        </label>
                      </div>
                    </div>
                  </td>
                  <td className="border border-gray-300 p-2">
                    <select 
                      className="input text-sm"
                      value={data.materialSpecs?.wallAngleOrderLength || ''}
                      onChange={(e) => handleLGSSelection('wallAngleOrderLength', e.target.value)}
                    >
                      <option value="">Select order length</option>
                      {orderLengthOptions.map(option => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr>
                  <td className="border border-gray-300 p-2">09 22 00</td>
                  <td className="border border-gray-300 p-2">Carrying Channel</td>
                  <td className="border border-gray-300 p-2">
                    <div>
                      <label className="grid gap-1">
                        <span className="text-xs font-medium">THICKNESS</span>
                        <select 
                          className="input text-sm"
                          value={data.materialSpecs?.carryingChannelThickness || ''}
                          onChange={(e) => handleLGSSelection('carryingChannelThickness', e.target.value)}
                        >
                          <option value="">Select thickness</option>
                          <option value="0.6mm">0.6mm</option>
                          <option value="0.7mm">0.7mm</option>
                          <option value="0.8mm">0.8mm</option>
                          <option value="0.9mm">0.9mm</option>
                          <option value="1.0mm">1.0mm</option>
                        </select>
                      </label>
                    </div>
                  </td>
                  <td className="border border-gray-300 p-2">
                    <select 
                      className="input text-sm"
                      value={data.materialSpecs?.carryingChannelOrderLength || ''}
                      onChange={(e) => handleLGSSelection('carryingChannelOrderLength', e.target.value)}
                    >
                      <option value="">Select order length</option>
                      {orderLengthOptions.map(option => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr>
                  <td className="border border-gray-300 p-2">09 22 00</td>
                  <td className="border border-gray-300 p-2">Furring</td>
                  <td className="border border-gray-300 p-2">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <div>
                        <label className="grid gap-1">
                          <span className="text-xs font-medium">TYPE</span>
                          <select 
                            className="input text-sm"
                            value={data.materialSpecs?.furringType || ''}
                            onChange={(e) => handleLGSSelection('furringType', e.target.value)}
                          >
                            <option value="">Select type</option>
                            <option value="single">Single</option>
                            <option value="double">Double</option>
                          </select>
                        </label>
                      </div>
                      <div>
                        <label className="grid gap-1">
                          <span className="text-xs font-medium">THICKNESS</span>
                          <select 
                            className="input text-sm"
                            value={data.materialSpecs?.furringThickness || ''}
                            onChange={(e) => handleLGSSelection('furringThickness', e.target.value)}
                          >
                            <option value="">Select thickness</option>
                            <option value="0.4mm">0.4mm</option>
                            <option value="0.5mm">0.5mm</option>
                            <option value="0.6mm">0.6mm</option>
                          </select>
                        </label>
                      </div>
                    </div>
                  </td>
                  <td className="border border-gray-300 p-2">
                    <select 
                      className="input text-sm"
                      value={data.materialSpecs?.furringOrderLength || ''}
                      onChange={(e) => handleLGSSelection('furringOrderLength', e.target.value)}
                    >
                      <option value="">Select order length</option>
                      {orderLengthOptions.map(option => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                      ))}
                    </select>
                  </td>
                </tr>

                <tr>
                  <td className="border border-gray-300 p-2">09 22 00</td>
                  <td className="border border-gray-300 p-2">CLIPS</td>
                  <td className="border border-gray-300 p-2">
                    <div>
                      <label className="grid gap-1">
                        <span className="text-xs font-medium">TYPE</span>
                        <select 
                          className="input text-sm"
                          value={data.materialSpecs?.clipsType || ''}
                          onChange={(e) => handleLGSSelection('clipsType', e.target.value)}
                        >
                          <option value="">Select type</option>
                          <option value="w_clip">W Clip</option>
                          <option value="wire_coupling_clip">Wire Coupling Clip</option>
                        </select>
                      </label>
                    </div>
                  </td>
                  <td className="border border-gray-300 p-2">
                    <div className="p-2 bg-gray-100 rounded text-sm text-gray-600">
                      Sold per piece
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Paint Only Section - for painted slab */}
      {data.ceilingType === 'ceiling_painted_slab' && (
        <div className="p-3 border border-green-200 rounded-lg bg-green-50 mb-4">
          <div className="font-semibold mb-3">Paint Specification</div>
          
          {/* Base Coat - Always Flat White */}
          <div className="mb-4 p-3 border border-gray-200 rounded-lg bg-gray-50">
            <div className="font-medium mb-2">Base Coat (Always Flat White)</div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="grid gap-1">
                  <span className="label">Base Coat Brand</span>
                  <select 
                    className="input"
                    value={data.materialSpecs?.baseCoatBrand || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        baseCoatBrand: e.target.value
                      }
                    })}
                  >
                    <option value="">Select brand</option>
                    <option value="main_paint">Main Paint</option>
                    <option value="alternate_paint_1">Alternate Paint 1</option>
                    <option value="alternate_paint_2">Alternate Paint 2</option>
                  </select>
                </label>
              </div>
              <div>
                <label className="grid gap-1">
                  <span className="label">Order Size</span>
                  <select 
                    className="input"
                    value={data.materialSpecs?.baseCoatOrderSize || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        baseCoatOrderSize: e.target.value
                      }
                    })}
                  >
                    <option value="">Select size</option>
                    {paintOrderSizes.map(size => (
                      <option key={size.value} value={size.value}>{size.label}</option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="flex items-end">
                <div className="p-2 bg-blue-50 border border-blue-200 rounded text-sm text-blue-700 font-medium">
                  Type: Flat White (Fixed)
                </div>
              </div>
            </div>
          </div>

          {/* Finish Coat */}
          <div className="p-3 border border-gray-200 rounded-lg bg-gray-50">
            <div className="font-medium mb-2">Finish Coat (Top Coat)</div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div>
                <label className="grid gap-1">
                  <span className="label">Finish Coat Brand</span>
                  <select 
                    className="input"
                    value={data.materialSpecs?.paintBrand || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        paintBrand: e.target.value
                      }
                    })}
                  >
                    <option value="">Select brand</option>
                    <option value="main_paint">Main Paint</option>
                    <option value="alternate_paint_1">Alternate Paint 1</option>
                    <option value="alternate_paint_2">Alternate Paint 2</option>
                  </select>
                </label>
              </div>
              <div>
                <label className="grid gap-1">
                  <span className="label">Paint Type</span>
                  <select 
                    className={`input ${!data.materialSpecs?.paintBrand ? 'disabled' : ''}`}
                    disabled={!data.materialSpecs?.paintBrand}
                    value={data.materialSpecs?.paintType || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        paintType: e.target.value
                      }
                    })}
                  >
                    <option value="">Select brand first</option>
                    {data.materialSpecs?.paintBrand === 'main_paint' && (
                      <>
                        <option value="premium_interior">Premium Interior Paint</option>
                        <option value="standard_interior">Standard Interior Paint</option>
                        <option value="eco_friendly">Eco-Friendly Paint</option>
                      </>
                    )}
                    {data.materialSpecs?.paintBrand === 'alternate_paint_1' && (
                      <>
                        <option value="budget_interior">Budget Interior Paint</option>
                        <option value="economy">Economy Paint</option>
                        <option value="basic">Basic Paint</option>
                      </>
                    )}
                    {data.materialSpecs?.paintBrand === 'alternate_paint_2' && (
                      <>
                        <option value="value_interior">Value Interior Paint</option>
                        <option value="cost_effective">Cost-Effective Paint</option>
                        <option value="general_purpose">General Purpose Paint</option>
                      </>
                    )}
                  </select>
                </label>
              </div>
              <div>
                <label className="grid gap-1">
                  <span className="label">Texture</span>
                  <select 
                    className="input"
                    value={data.materialSpecs?.paintTexture || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        paintTexture: e.target.value
                      }
                    })}
                  >
                    <option value="">Select texture</option>
                    <option value="flat">Flat</option>
                    <option value="gloss">Gloss</option>
                    <option value="semi_gloss">Semi Gloss</option>
                    <option value="matt">Matt</option>
                    <option value="eggshell">Eggshell</option>
                  </select>
                </label>
              </div>
              <div>
                <label className="grid gap-1">
                  <span className="label">Order Size</span>
                  <select 
                    className="input"
                    value={data.materialSpecs?.finishCoatOrderSize || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        finishCoatOrderSize: e.target.value
                      }
                    })}
                  >
                    <option value="">Select size</option>
                    {paintOrderSizes.map(size => (
                      <option key={size.value} value={size.value}>{size.label}</option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* B. Ceiling Surface & Accessories - for non-painted slab options */}
      {data.ceilingType && data.ceilingType !== 'ceiling_painted_slab' && (
        <div className="p-4 border border-purple-200 rounded-lg bg-purple-50 mb-6">
          <div className="font-semibold mb-4 text-purple-800">B. Ceiling Surface & Accessories</div>
          <p className="note mb-3">Select ceiling board material (one type only)</p>

          {/* Painted Fiber Cement */}
          <label className="flex items-start gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer mb-4">
            <input 
              type="radio" 
              name="material_type" 
              checked={data.materialType === 'fibercement'}
              onChange={() => updateData({ materialType: 'fibercement' })}
              className="mt-1" 
            />
            <div className="flex-1">
              <div className="font-semibold mb-3">09 28 00 - Painted Fiber Cement</div>
              {data.materialType === 'fibercement' && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="grid gap-1">
                      <span className="label">Thickness</span>
                      <select 
                        className="input"
                        value={data.materialSpecs?.fibercementThickness || ''}
                        onChange={(e) => updateData({
                          materialSpecs: {
                            ...data.materialSpecs,
                            fibercementThickness: e.target.value
                          }
                        })}
                      >
                        <option value="">Select thickness</option>
                        <option value="6mm">6mm</option>
                        <option value="8mm">8mm</option>
                        <option value="10mm">10mm</option>
                        <option value="12mm">12mm</option>
                      </select>
                    </label>
                  </div>
                  <div>
                    <label className="grid gap-1">
                      <span className="label">Brand</span>
                      <select 
                        className="input"
                        value={data.materialSpecs?.fibercementBrand || ''}
                        onChange={(e) => updateData({
                          materialSpecs: {
                            ...data.materialSpecs,
                            fibercementBrand: e.target.value
                          }
                        })}
                      >
                        <option value="">Select brand</option>
                        <option value="gardner">Gardner</option>
                        <option value="alternate_fibercement_1">Alternate Fibercement 1</option>
                        <option value="alternate_fibercement_2">Alternate Fibercement 2</option>
                      </select>
                    </label>
                  </div>
                  <div className="md:col-span-2">
                    <div className="p-2 bg-gray-100 rounded text-sm text-gray-600">
                      <strong>Automatically included:</strong> Fiber Cement Board Screw (32–45 mm, corrosion-resistant)
                    </div>
                  </div>
                </div>
              )}
            </div>
          </label>

          {/* Painted Gypsum */}
          <label className="flex items-start gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer mb-4">
            <input 
              type="radio" 
              name="material_type" 
              checked={data.materialType === 'gypsum'}
              onChange={() => updateData({ materialType: 'gypsum' })}
              className="mt-1" 
            />
            <div className="flex-1">
              <div className="font-semibold mb-3">09 29 00 - Painted Gypsum</div>
              {data.materialType === 'gypsum' && (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="grid gap-1">
                      <span className="label">Type</span>
                      <select 
                        className="input"
                        value={data.materialSpecs?.gypsumType || ''}
                        onChange={(e) => updateData({
                          materialSpecs: {
                            ...data.materialSpecs,
                            gypsumType: e.target.value
                          }
                        })}
                      >
                        <option value="">Select type</option>
                        <option value="ordinary">Ordinary</option>
                        <option value="fire_rated">Fire Rated</option>
                        <option value="moisture_resistant">Moisture Resistant</option>
                        <option value="acoustic_panel">Acoustic Panel</option>
                      </select>
                    </label>
                  </div>
                  <div>
                    <label className="grid gap-1">
                      <span className="label">Thickness</span>
                      <select 
                        className="input"
                        value={data.materialSpecs?.gypsumThickness || ''}
                        onChange={(e) => updateData({
                          materialSpecs: {
                            ...data.materialSpecs,
                            gypsumThickness: e.target.value
                          }
                        })}
                      >
                        <option value="">Select thickness</option>
                        <option value="6mm">6mm</option>
                        <option value="8mm">8mm</option>
                        <option value="10mm">10mm</option>
                        <option value="12mm">12mm</option>
                      </select>
                    </label>
                  </div>
                  <div>
                    <label className="grid gap-1">
                      <span className="label">Brand</span>
                      <select 
                        className="input"
                        value={data.materialSpecs?.gypsumBrand || ''}
                        onChange={(e) => updateData({
                          materialSpecs: {
                            ...data.materialSpecs,
                            gypsumBrand: e.target.value
                          }
                        })}
                      >
                        <option value="">Select brand</option>
                        <option value="eastberg">Eastberg</option>
                        <option value="alternate_gypsum_1">Alternate Gypsum 1</option>
                        <option value="alternate_gypsum_2">Alternate Gypsum 2</option>
                      </select>
                    </label>
                  </div>
                  <div className="md:col-span-3">
                    <div className="p-2 bg-gray-100 rounded text-sm text-gray-600">
                      <strong>Automatically included:</strong> Gypsum Board Screw (25–32 mm, black phosphate)
                    </div>
                  </div>
                </div>
              )}
            </div>
          </label>

          {/* PVC Ceiling */}
          <label className="flex items-start gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer mb-4">
            <input 
              type="radio" 
              name="material_type" 
              checked={data.materialType === 'pvc'}
              onChange={() => updateData({ materialType: 'pvc' })}
              className="mt-1" 
            />
            <div className="flex-1">
              <div className="font-semibold mb-3">06 64 00 - PVC</div>
              {data.materialType === 'pvc' && (
                <div className="grid grid-cols-1 gap-4">
                  <div>
                    <label className="grid gap-1">
                      <span className="label">Brand</span>
                      <select 
                        className="input"
                        value={data.materialSpecs?.pvcBrand || ''}
                        onChange={(e) => updateData({
                          materialSpecs: {
                            ...data.materialSpecs,
                            pvcBrand: e.target.value
                          }
                        })}
                      >
                        <option value="">Select brand</option>
                        <option value="main_pvc">Main PVC</option>
                        <option value="alternate_pvc_1">Alternate PVC 1</option>
                        <option value="alternate_pvc_2">Alternate PVC 2</option>
                      </select>
                    </label>
                  </div>
                </div>
              )}
            </div>
          </label>
        </div>
      )}

      {/* C. Ceiling Finish (Paints and Coatings) - only for gypsum and fibercement */}
      {(data.materialType === 'gypsum' || data.materialType === 'fibercement') && (
        <div className="p-4 border border-orange-200 rounded-lg bg-orange-50 mb-4">
          <div className="font-semibold mb-4 text-orange-800">C. Ceiling Finish (Paints and Coatings)</div>
          
          {/* Jointing Materials */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="grid gap-1">
                <span className="label">09 29 00 - Jointing Tape Brand</span>
                <select 
                  className="input"
                  value={data.materialSpecs?.jointingTapeBrand || ''}
                  onChange={(e) => updateData({
                    materialSpecs: {
                      ...data.materialSpecs,
                      jointingTapeBrand: e.target.value
                    }
                  })}
                >
                  <option value="">Select tape brand</option>
                  <option value="main_tape">Main Tape</option>
                  <option value="alternate_tape_1">Alternate Tape 1</option>
                  <option value="alternate_tape_2">Alternate Tape 2</option>
                </select>
              </label>
              <label className="grid gap-1 mt-2">
                <span className="label">Tape Order Size</span>
                <select 
                  className="input"
                  value={data.materialSpecs?.tapeOrderSize || ''}
                  onChange={(e) => updateData({
                    materialSpecs: {
                      ...data.materialSpecs,
                      tapeOrderSize: e.target.value
                    }
                  })}
                >
                  <option value="">Select size</option>
                  {tapeOrderSizes.map(size => (
                    <option key={size.value} value={size.value}>{size.label}</option>
                  ))}
                </select>
              </label>
            </div>
            <div>
              <label className="grid gap-1">
                <span className="label">09 90 00 - Jointing Putty Brand</span>
                <select 
                  className="input"
                  value={data.materialSpecs?.jointingPuttyBrand || ''}
                  onChange={(e) => updateData({
                    materialSpecs: {
                      ...data.materialSpecs,
                      jointingPuttyBrand: e.target.value
                    }
                  })}
                >
                  <option value="">Select putty brand</option>
                  <option value="main_putty">Main Putty</option>
                  <option value="alternate_putty_1">Alternate Putty 1</option>
                  <option value="alternate_putty_2">Alternate Putty 2</option>
                </select>
              </label>
            </div>
          </div>

          {/* Base Coat - Always Flat White */}
          <div className="mb-4 p-3 border border-gray-200 rounded-lg bg-gray-50">
            <div className="font-medium mb-2">09 90 00 - Base Coat (Always Flat White)</div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="grid gap-1">
                  <span className="label">Base Coat Brand</span>
                  <select 
                    className="input"
                    value={data.materialSpecs?.baseCoatBrand || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        baseCoatBrand: e.target.value
                      }
                    })}
                  >
                    <option value="">Select brand</option>
                    <option value="main_paint">Main Paint</option>
                    <option value="alternate_paint_1">Alternate Paint 1</option>
                    <option value="alternate_paint_2">Alternate Paint 2</option>
                  </select>
                </label>
              </div>
              <div>
                <label className="grid gap-1">
                  <span className="label">Order Size</span>
                  <select 
                    className="input"
                    value={data.materialSpecs?.baseCoatOrderSize || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        baseCoatOrderSize: e.target.value
                      }
                    })}
                  >
                    <option value="">Select size</option>
                    {paintOrderSizes.map(size => (
                      <option key={size.value} value={size.value}>{size.label}</option>
                    ))}
                  </select>
                </label>
              </div>
              <div className="flex items-end">
                <div className="p-2 bg-blue-50 border border-blue-200 rounded text-sm text-blue-700 font-medium">
                  Type: Flat White (Fixed)
                </div>
              </div>
            </div>
          </div>

          {/* Finish Coat System */}
          <div className="p-3 border border-gray-200 rounded-lg bg-gray-50 mb-4">
            <div className="font-medium mb-2">09 90 00 - Finish Coat (Top Coat)</div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div>
                <label className="grid gap-1">
                  <span className="label">Finish Coat Brand</span>
                  <select 
                    className="input"
                    value={data.materialSpecs?.paintBrand || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        paintBrand: e.target.value
                      }
                    })}
                  >
                    <option value="">Select brand</option>
                    <option value="main_paint">Main Paint</option>
                    <option value="alternate_paint_1">Alternate Paint 1</option>
                    <option value="alternate_paint_2">Alternate Paint 2</option>
                  </select>
                </label>
              </div>
              <div>
                <label className="grid gap-1">
                  <span className="label">Type</span>
                  <select 
                    className={`input ${!data.materialSpecs?.paintBrand ? 'disabled' : ''}`}
                    disabled={!data.materialSpecs?.paintBrand}
                    value={data.materialSpecs?.paintType || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        paintType: e.target.value
                      }
                    })}
                  >
                    <option value="">Select brand first</option>
                    {data.materialSpecs?.paintBrand === 'main_paint' && (
                      <>
                        <option value="premium_interior">Premium Interior Paint</option>
                        <option value="standard_interior">Standard Interior Paint</option>
                        <option value="eco_friendly">Eco-Friendly Paint</option>
                      </>
                    )}
                    {data.materialSpecs?.paintBrand === 'alternate_paint_1' && (
                      <>
                        <option value="budget_interior">Budget Interior Paint</option>
                        <option value="economy">Economy Paint</option>
                        <option value="basic">Basic Paint</option>
                      </>
                    )}
                    {data.materialSpecs?.paintBrand === 'alternate_paint_2' && (
                      <>
                        <option value="value_interior">Value Interior Paint</option>
                        <option value="cost_effective">Cost-Effective Paint</option>
                        <option value="general_purpose">General Purpose Paint</option>
                      </>
                    )}
                  </select>
                </label>
              </div>
              <div>
                <label className="grid gap-1">
                  <span className="label">Texture</span>
                  <select 
                    className="input"
                    value={data.materialSpecs?.paintTexture || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        paintTexture: e.target.value
                      }
                    })}
                  >
                    <option value="">Select texture</option>
                    <option value="flat">Flat</option>
                    <option value="gloss">Gloss</option>
                    <option value="semi_gloss">Semi Gloss</option>
                    <option value="matt">Matt</option>
                    <option value="eggshell">Eggshell</option>
                  </select>
                </label>
              </div>
              <div>
                <label className="grid gap-1">
                  <span className="label">Order Size</span>
                  <select 
                    className="input"
                    value={data.materialSpecs?.finishCoatOrderSize || ''}
                    onChange={(e) => updateData({
                      materialSpecs: {
                        ...data.materialSpecs,
                        finishCoatOrderSize: e.target.value
                      }
                    })}
                  >
                    <option value="">Select size</option>
                    {paintOrderSizes.map(size => (
                      <option key={size.value} value={size.value}>{size.label}</option>
                    ))}
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* D. ALLOWANCES */}
      <div className="p-4 border border-green-200 rounded-lg bg-green-50 mb-4">
        <div className="font-semibold mb-4 text-green-800">D. ALLOWANCES</div>
        <p className="note mb-3">Specify percentage allowances for waste, cutting, and installation contingencies</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="grid gap-1">
              <span className="label">A. LGS Framing Allowance (%)</span>
              <select 
                className="input"
                value={data.materialSpecs?.allowances?.lgsFraming || ''}
                onChange={(e) => handleAllowanceChange('lgsFraming', e.target.value)}
              >
                <option value="">Select allowance</option>
                <option value="5">5% - Minimal waste</option>
                <option value="10">10% - Standard allowance</option>
                <option value="15">15% - High waste expected</option>
                <option value="20">20% - Complex installation</option>
              </select>
            </label>
          </div>
          <div>
            <label className="grid gap-1">
              <span className="label">B. Ceiling Surface Allowance (%)</span>
              <select 
                className="input"
                value={data.materialSpecs?.allowances?.ceilingSurface || ''}
                onChange={(e) => handleAllowanceChange('ceilingSurface', e.target.value)}
              >
                <option value="">Select allowance</option>
                <option value="5">5% - Minimal waste</option>
                <option value="10">10% - Standard allowance</option>
                <option value="15">15% - High waste expected</option>
                <option value="20">20% - Complex cuts/patterns</option>
              </select>
            </label>
          </div>
          <div>
            <label className="grid gap-1">
              <span className="label">C. Paint & Coatings Allowance (%)</span>
              <select 
                className="input"
                value={data.materialSpecs?.allowances?.paintCoatings || ''}
                onChange={(e) => handleAllowanceChange('paintCoatings', e.target.value)}
              >
                <option value="">Select allowance</option>
                <option value="5">5% - Minimal waste</option>
                <option value="10">10% - Standard allowance</option>
                <option value="15">15% - High waste expected</option>
                <option value="20">20% - Touch-ups included</option>
              </select>
            </label>
          </div>
        </div>
        <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded text-sm text-blue-700">
          <strong>Note:</strong> Allowances account for material waste during cutting, installation errors, future maintenance, and project-specific complexities. Higher percentages recommended for irregular spaces or detailed work.
        </div>
      </div>

      {/* Special Requirements */}
      <div className="grid gap-2">
        <span className="label">Special Requirements</span>
        <textarea 
          className="input" 
          rows="3" 
          placeholder="Enter any special requirements or notes..."
          value={data.specialRequirements || ''}
          onChange={(e) => updateData({ specialRequirements: e.target.value })}
        ></textarea>
      </div>
    </div>
  );
};

export default MaterialSpecifications;